<template lang="html">
<div class="localization">
    <div class="Vlt-native-dropdown">
        <select v-model="langSel" @change="languageChange">
            <option v-for="(lang,index) in dialects" v-bind:key="index" :value="index">{{ lang.language }}</option>
        </select>
    </div>
</div>
</template>

<script lang="js">
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltDropdown,
    VltCheckbox,
} from "@vonagevolta/vue";

export default {
    name: 'localization',
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-dropdown": VltDropdown,
        "vlt-input": VltInput,
        "vlt-checkbox": VltCheckbox,
    },
    props: {
        langStart: {
            type: String,
            required: false
        },
    },
    data() {
        return {
            langSel: 0,
            language: null,
            lang: null,
            dialects: [{
                    language: 'English',
                    code: 'EN',
                    subcode: 'EN'
                },
                {
                    language: 'Arabic/Jordan',
                    code: 'AR',
                    subcode: 'ar-JO'
                },
                {
                    language: 'Arabic/Saudi Arabia',
                    code: 'AR',
                    subcode: 'ar-SA'
                },
                {
                    language: 'Arabic/UAE',
                    code: 'AR',
                    subcode: 'ar-AE'
                },
            ],
            localization: [{
                    language: 'English',
                    code: 'EN',
                    fields: {
                        connect: 'Connect',
                        disconnect: 'Disconnected',
                        customer: 'Customer',
                        courier: 'Courier',
                        dispatcher: 'Dispatcher',
                        sentiment: 'Sentiment',
                        initiate: 'Initiate Service',
                        time: 'Time',
                        date: 'Date',
                        from: 'From',
                        status: 'Status',
                        directions: 'Directions',
                        actions: 'Actions',
                        pending: 'Pending',
                        pickup: 'Pickup',
                        delivery: 'Delivery',
                        reschedule: 'Unschedule',
                        rescheduled: 'Unscheduled',
                        complete: 'Complete',
                        completed: 'Completed',
                        refresh: 'Refresh',
                        reset: 'Reset',
                        sendlink: 'Send Link to Customer',
                        sentlink: 'Sent Link to Customer',
                        live: 'Live Call',
                        language: 'Language',
                        english: 'English',
                        arabic: 'Arabic',
                        browse: 'Browse Conversation',
                        sendtext: 'Send Text Message',
                        record: 'Record/Send Note',
                        voicenote: 'Voice Note',
                        sendimage: 'Send Image',
                        image: 'Image',
                        audio: 'Audio',
                        sent: 'Sent',
                        received: 'Received',
                        from: 'from',
                        to: 'to',
                        page: 'Page Courier',
                        paged: 'Paged by Customer',
                        other: 'Other',
                        play: 'Play',
                        playaudio: 'Play Audio',
                        sendastext: 'Send as Text',
                        sendasaudio: 'Send as Audio',
                        processing: 'Processing',
                        transcription: 'Transcription',
                        hangup: 'Hang Up',
                        cancel: 'Cancel',
                        showimage: 'Show Image',
                        upload: 'Upload and Send Image',
                        incall: 'In Call',
                        dismiss: 'Dismiss',
                        callcustomer: 'Call Customer',
                        customerpaging: 'Customer Paging',
                        pagingmsg: 'The Customer would like to speak with you. Press "Call Customer" to connect.',
                        loadingconvo: 'Loading Conversation',
                        convoevents: 'Conversation Event Browser',
                        noloco: 'Geolocation is not available',
                        in: 'in',
                        service: 'Service',
                        at: 'at',
                        event: 'Event',
                        text: 'Text',
                        disppage: 'The Customer would like to speak with you. Press "Call Customer" to connect.',
                        close: 'Close',
                        called: 'Called',
                        addcustomer: 'Add Customer',
                        customers: 'Customers',
                        link: 'link',
                        links: 'Links',
                        recaudio: 'Recording Audio Note',
                        stoprec: 'Stop Recording',
                        name: 'Name',
                        address: 'Address',
                        area: 'Area',
                        phone: 'Phone',
                        notes: 'Notes',
                        send: 'Send',
                        done: 'Done',
                        for: 'for',
                        delete: 'Delete',
                        update: 'Update',
                        activity: 'Activity',
                        demo: 'Demo',

                    }
                },
                {
                    language: 'Arabic',
                    code: 'AR',
                    fields: {
                        connect: 'الاتصال',
                        disconnect: 'قطع الاتصال',
                        customer: 'العميل',
                        courier: 'التوصيل',
                        dispatcher: 'المرسل',
                        sentiment: 'المشاعر',
                        initiate: 'بدء الخدمة',
                        time: 'وقت',
                        date: 'تاريخ',
                        from: 'من',
                        status: 'حالة',
                        directions: 'إتجاهات',
                        actions: 'أجراءات',
                        pending: 'قيد الانتظار',
                        pickup: 'إستلم',
                        delivery: 'توصيل',
                        reschedule: 'إعادة الجدولة',
                        rescheduled: ' تم إعادة الجدولة ',
                        complete: 'إكمال',
                        completed: 'إكتمل',
                        refresh: 'تحديث',
                        reset: 'إعادة تعيين',
                        sendlink: 'إرسال الرابط للعميل',
                        sentlink: ' تم إرسال الرابط للعميل ',
                        live: 'مكالمة مباشرة',
                        language: 'لغة',
                        english: 'لغة إنجليزية',
                        arabic: 'لغة عربية',
                        browse: 'متصفح المحادثة',
                        sendtext: 'أرسل رسالة نصية',
                        record: ' سجل رسالة صوتية',
                        voicenote: 'رسالة صوتية',
                        sendimage: 'أرسل صورة',
                        image: 'صورة',
                        audio: 'ملف صوتي',
                        sent: 'تم إرسال',
                        received: 'تم الإستلام',
                        from: 'من',
                        to: 'إلى',
                        page: 'إتصل بشركة الشحن',
                        paged: 'تم الاتصال من قبل العميل',
                        other: 'أخرى',
                        play: 'تشغيل',
                        playaudio: 'تشغيل ملف صوتي',
                        sendastext: 'أرسل رسالة نصية',
                        sendasaudio: 'أرسل رسالة صوتية',
                        processing: 'جاري المعالجة ',
                        transcription: 'نسخ',
                        hangup: 'إنهاء المكالمة',
                        cancel: 'إلغاء',
                        showimage: 'عرض صورة',
                        upload: 'حمل وأرسل صورة',
                        incall: 'في المكالمة',
                        dismiss: 'رفض',
                        callcustomer: 'إتصل بالعميل',
                        customerpaging: 'استدعاء العملاء',
                        pagingmsg: 'يود العميل التحدث معك. اضغط على "الاتصال بالعميل" للاتصال.',
                        loadingconvo: 'تحميل المحادثة',
                        convoevents: 'متصفح المحادثة',
                        noloco: 'معرف المحادثة',
                        in: 'في',
                        service: 'الخدمة',
                        at: 'في',
                        event: 'حدث',
                        text: 'نص',
                        pagingmsg: 'يود العميل التحدث معك. اضغط على "الاتصال بالعميل" للاتصال.',
                        close: 'قريب',
                        called: 'اتصل',
                        addcustomer: 'أضف العميل',
                        customers: 'العملاء',
                        link: 'حلقة الوصل',
                        links: 'الروابط',
                        recaudio: 'تسجيل رسالة صوتية',
                        stoprec: 'إيقاف التسجيل',
                        name: 'اسم',
                        address: 'عنوان',
                        area: 'منطقة',
                        phone: 'رقم الهاتف',
                        notes: 'ملاحظات',
                        send: 'إرسال',
                        done: 'منجز',
                        for: 'إلى عن على',
                        delete: 'حذف',
                        update: 'تحديث',
                        activity: 'نشاط',
                        demo: 'تجريبي',

                    },
                }
            ]
        }
    },
    watch: {},
    methods: {
        languageChange() {
            let code = this.dialects[this.langSel].code;
            let base = this.localization.findIndex((o) => o.code == code);
            this.language = this.localization[base];
            this.lang = this.language.fields;
            this.language.dialect = this.dialects[this.langSel].subcode;
            this.$emit("language", this.language);
        },
    },
    created() {
        console.log("in Localization");
        this.$emit("baselang", this.localization[0].fields);
        this.langSel = this.localization.findIndex((o) => o.code == this.langStart);
        console.log("langStart = " + this.langStart + " is index " + this.langSel);
        this.languageChange();
    },
    mounted() {},

}
</script>

<style scoped lang="scss">
</style>
